import { useState } from "react";
import { Button } from "@/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/ui/dialog";
import { Textarea } from "@/ui/textarea";

/** Khớp `certgate.ValidReason` phía máy chủ (≥ 5 ký tự sau khi cắt khoảng trắng). */
const CERT_REASON_MIN = 5;

type Props = {
  open: boolean;
  personName: string;
  /** Nhãn chuyên ngành, ví dụ "Ảnh profile". */
  label: string;
  pending?: boolean;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
};

/**
 * Hộp lý do khi gán người thiếu chứng chỉ ở chế độ CHẶN (spec §7.1, §9).
 * Hộp thoại nội tuyến, KHÔNG `window.prompt` — prompt chết câm trong webview.
 */
export function CertReasonDialog({ open, personName, label, pending = false, onCancel, onConfirm }: Props) {
  const [reason, setReason] = useState("");
  const ok = reason.trim().length >= CERT_REASON_MIN;
  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        if (!o) onCancel();
      }}
    >
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Gán ngoại lệ chứng chỉ</DialogTitle>
          <DialogDescription>
            {personName} chưa có chứng chỉ {label} còn hiệu lực. Ghi lý do (ít nhất{" "}
            {CERT_REASON_MIN} ký tự) để gán ngoại lệ — lý do được lưu kèm đơn.
          </DialogDescription>
        </DialogHeader>
        <Textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Ví dụ: ca sáng thiếu người, khách đã chờ 20 phút"
          rows={3}
          aria-label="Lý do gán ngoại lệ"
        />
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={pending}>
            Huỷ
          </Button>
          <Button onClick={() => onConfirm(reason.trim())} disabled={!ok || pending}>
            Gán ngoại lệ
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
